import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { alertError, alertSuccess } from "../../../utils/logger";

const CreateProductCatalogDialog = ({
  open,
  setOpen,
  title,
  fields,
  saveEntity,
  successMessage,
  errorMessage,
  onSaved,
	entityToEdit = null,
}) => {
  const [values, setValues] = useState({});
  const loggedUser = useSelector((store) => store.authentication?.user, shallowEqual);

  useEffect(() => {
    if (open) {
      setValues((fields || []).reduce((result, field) => {
		result[field.name] = entityToEdit?.[field.name] || "";
        return result;
      }, {}));
    }
  }, [open, fields, entityToEdit]);

  const save = async () => {
    const trimmedValues = Object.keys(values).reduce((result, key) => {
      result[key] = values[key]?.trim() || null;
      return result;
    }, {});
    const missingRequired = (fields || []).some(
      (field) => field.required && !trimmedValues[field.name]
    );

    if (missingRequired) {
      alertError({ error: "Completa los campos obligatorios." });
      return;
    }

    try {
      const response = await saveEntity(trimmedValues, loggedUser?.accessToken);
      if ([200, 201, 204].includes(response.status)) {
        alertSuccess({ title: "¡Guardado!", customMessage: successMessage });
        if (onSaved) {
		  onSaved(response.data || { ...trimmedValues, id: entityToEdit?.id });
        }
        setOpen(false);
      }
    } catch (error) {
      alertError({ error, customMessage: errorMessage });
    }
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={Boolean(open)} onClose={() => setOpen(false)} className="backdrop">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {(fields || []).map((field, index) => (
          <TextField
            key={field.name}
            autoFocus={index === 0}
            fullWidth
            required={field.required}
            label={field.label}
            value={values[field.name] || ""}
            onChange={(event) => setValues({ ...values, [field.name]: event.target.value })}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant="outlined">Cancelar</Button>
        <Button onClick={save} color="primary" variant="outlined">Guardar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateProductCatalogDialog;
